export function extractError(error) {
    return ((error &&
        "graphQLErrors" in error &&
        error.graphQLErrors &&
        error.graphQLErrors.length &&
        error.graphQLErrors[0]) ||
        error);
}
export function getExceptionFromError(error) {
    // @ts-ignore
    const graphqlError = extractError(error);
    const exception = graphqlError?.extensions?.exception;
    return exception || graphqlError || error;
}
export function getCodeFromError(error) {
    const err = getExceptionFromError(error);
    return (err && err["code"]) || null;
}
//# sourceMappingURL=errors.js.map